import { createFileRoute } from '@tanstack/react-router';
import { requireAuth } from '~/lib/session/session.singleton';
import { MainLayout } from '~/shared/layout/layout.components/main-layout';

export const Route = createFileRoute('/_main-layout')({
  beforeLoad: requireAuth,
  component: MainLayout,
});
